// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("../../../../node_modules/.pnpm/@umijs+bundler-webpack@4.7.22_type-fest@4.41.0_typescript@6.0.3_webpack@5.107.2_esbuild@0.28.2_lightningcss@1.33.0_/node_modules/@umijs/bundler-webpack/client/client/client.js");
var __webpack_exports__ = __webpack_require__("./src/.umi/umi.ts");
